



export const extractErrorMessage = (err) => {
    if (!err) return 'An unexpected error occurred';

    // Axios-like error: get response.data if available
    const response = err?.response?.data || err?.response || err;

    // Case 1: direct message
    if (response?.message) return response.message;

    // Case 2: nested error object
    if (response?.error?.message) return response.error.message;

    // Case 3: validation errors
    if (response?.errors && typeof response.errors === 'object') {
        const firstField = Object.keys(response.errors)[0];
        const messages = response.errors[firstField];
        if (Array.isArray(messages)) return messages[0];
        return messages;
    }

    // Fallback to err.message if available
    if (err?.message) return err.message;

    return 'Something went wrong. Please try again.';
};